import {FC, memo} from 'react'
import { KTSVG } from '../../../../../../../_metronic/helpers'

export type UploadContactHeaderProps = {
  title: string
  handleClose: () => void
}
const UploadContactHeader: FC<UploadContactHeaderProps> = (props) => {
  const {title, handleClose} = props

  return (
    <div className='modal-header'>
      <h1>{title}</h1>
      <div className='btn btn-icon btn-sm' onClick={handleClose}>
        <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
      </div>
    </div>
  )
}

export default memo(UploadContactHeader)
